import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client';
import cacheConfig from './cacheConfigs';
import errorLink from './errorLink';
import networkStatusLink from './networkStatusLink';

const httpLink = new HttpLink({
  uri: `${import.meta.env.VITE_DB_URL}/graphql`,
  credentials: 'include',  // This is what makes HttpOnly cookies work
});

const authLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: { ...headers, source: 'scheduler_dashboard' }, // What is source, why did we have this?
  }));
  return forward(operation);
});

export const client = new ApolloClient({
  link: ApolloLink.from([errorLink, authLink, networkStatusLink, httpLink]),
  cache: cacheConfig,
  assumeImmutableResults: true,
});